import { __assign } from "tslib";
import * as whizadAPI from "../../admin-service-typescript-client";
export var createNetworkClient = function (user) {
    return;
};
export var pageHandler = function (response, page) {
    if (response === null ||
        response.totalElements === undefined ||
        response.size === undefined ||
        (page !== "first" &&
            page !== "last" &&
            page !== "next" &&
            page !== "previous" &&
            page < 0 &&
            typeof page !== "number")) {
        throw Error;
    }
    switch (page) {
        case "first":
            return {
                size: response.size,
                page: 0
            };
        case "last":
            return {
                size: response.size,
                page: response.totalElements % response.size === 0
                    ? response.totalElements / response.size - 1
                    : Math.floor(response.totalElements / response.size)
            };
        case "next":
            if (!response.hasNext)
                throw Error;
            return __assign({}, response.nextPage);
        case "previous":
            if (!response.hasPrevious)
                throw Error;
            return __assign({}, response.previousPage);
        default:
            return {
                size: response.size,
                page: page
            };
    }
};
var ApiClient = /** @class */ (function () {
    function ApiClient(user) {
        this.setConfiguration(new whizadAPI.Configuration({
            accessToken: "Bearer " + user.token,
            headers: {
                "Content-Type": "application/json"
            },
            middleware: [
                {
                    pre: function (context) {
                        return;
                    },
                    post: function (context) {
                        return;
                    }
                },
            ]
        }));
        this.setAllClients();
    }
    ApiClient.prototype.setAllClients = function () {
        this.networkClient = new whizadAPI.NetworkRestControllerApi(this.configuration);
        this.locationClient = new whizadAPI.LocationRestControllerApi(this.configuration);
        this.playerClient = new whizadAPI.PlayerRestControllerApi(this.configuration);
        this.userClient = new whizadAPI.UserRestControllerApi(this.configuration);
        this.campaignClient = new whizadAPI.CampaignRestControllerApi(this.configuration);
        this.campaignWrapperClient =
            new whizadAPI.CampaignWrapperRestControllerApi(this.configuration);
        this.tagClient = new whizadAPI.TagRestControllerApi(this.configuration);
        this.userAuthorityClient = new whizadAPI.UserAuthorityRestControllerApi(this.configuration);
        this.organisationClient = new whizadAPI.OrganisationRestControllerApi(this.configuration);
        this.contentClient = new whizadAPI.ContentRestControllerApi(this.configuration);
        this.accessGrantClient = new whizadAPI.AccessGrantRestControllerApi(this.configuration);
        this.stationImport = new whizadAPI.ManagementRestControllerApi(this.configuration);
    };
    ApiClient.prototype.setConfiguration = function (config) {
        this.configuration = config;
    };
    /**
     *
     * @param user
     * @returns ApiClient
     */
    ApiClient.getInstance = function (user) {
        if (user) {
            ApiClient.instance = new ApiClient(user);
        }
        else if (!ApiClient.instance && !user) {
            return;
        }
        return ApiClient.instance;
    };
    return ApiClient;
}());
export { ApiClient };
